const SEARCH_COMMANDBAR_PROPS = {
  ariaLabel: "Search options"
};
const SEARCH_LINK_PROPS = {
  key: "search",
  ariaLabel: "Search",
  iconProps: {
    iconName: "Search"
  },
  name: "Search"
};
const SEARCH_TEXT_FIELD_PROPS = {
  placeholder: "Search by keyboard",
  ariaLabel: "Search by keyboard",
  iconProps: { iconName: "Search" }
};
const FILTER_COMMANDBAR_PROPS = {
  ariaLabel: "Filter options"
};
const FILTER_LINK_PROPS = {
  key: "filter",
  ariaLabel: "Filter",
  iconProps: {
    iconName: "Filter"
  },
  name: "Filter"
};
const REFRESH_LINK_PROPS = {
  key: "refresh",
  text: "Refresh",
  ariaLabel: "Refresh",
  iconProps: { iconName: "Refresh" }
};
const FILTER_TEXT_FIELD_PROPS = {
  ariaLabel: "Filter by keyword",
  placeholder: "Filter by keyword",
  iconProps: { iconName: "Filter" }
};
export {
  FILTER_COMMANDBAR_PROPS,
  FILTER_LINK_PROPS,
  FILTER_TEXT_FIELD_PROPS,
  REFRESH_LINK_PROPS,
  SEARCH_COMMANDBAR_PROPS,
  SEARCH_LINK_PROPS,
  SEARCH_TEXT_FIELD_PROPS
};
//# sourceMappingURL=DetailsListWithCommandBar.constants.js.map
